export const googlemapsConfig = {
  key: window["env"]["googlemapsKey"] || ""
};
